import { type PayloadAction } from "@reduxjs/toolkit";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../Application/slices/createFetchingItemsSlice";
import ReducerNamespaceTypes from "../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../enums/reducer/reducerEntityPrefixTypes";
import { type ContentResponse } from "features/Application/services/dataServices/contentDataService";

// Define a type for the slice state, extending FetchingItemsState
export interface ExternalLinksOverviewState extends FetchingItemsState<ContentResponse> {
  // Add any custom state properties for the overview page here, e.g., filters, searchTerm
  searchTerm?: string;
  selected: number[];
  // Example filter property:
  // statusFilter?: 'all' | 'draft' | 'published';
}

// Define the initial state
const initialState: ExternalLinksOverviewState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined, // Consistent with FetchingItemsState which uses 'error?: Error'
  areAllLoaded: false, // Initialize areAllLoaded
  searchTerm: "",
  selected: [],
  // statusFilter: 'all',
};

const externalLinksOverviewSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ExternalLinks,
    name: "externalLinksOverview", // Specific name for this slice's actions
  },
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<number[]>) => {
      state.selected = action.payload;
    },
    resetExternalLinksOverviewState: () => initialState, // Action to reset to initial state
  },
});

// Export the actions. fetchBegin, fetchSuccess, fetchFailure, reset are provided by createFetchingItemsSlice
// plus any custom reducers you defined.
export const { fetchBegin, fetchSuccess, fetchFailure, reset, setSelected, resetExternalLinksOverviewState } =
  externalLinksOverviewSlice.actions;

export default externalLinksOverviewSlice.reducer;
